import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePageHeader } from "../components/shell/PageHeaderContext";

/** The iA assistant has a place in the navigation by design; the conversation itself is not built yet. */
export function AssistantPage() {
  usePageHeader("Asistente iA", "Planea, compara y ahorra con ayuda de Aventuria iA.");
  const navigate = useNavigate();
  return (
    <div className="page-container">
      <section className="assistant-hero">
        <span className="ia-mark"><Sparkles size={26} aria-hidden="true" /></span>
        <h2>Tu asistente de viaje llega pronto.</h2>
        <p>Mientras tanto, explora destinos y define tu sueño: cuando el asistente esté disponible, partirá de lo que ya ahorraste.</p>
        <div className="inline-actions">
          <button type="button" className="primary-button" onClick={() => navigate("/explorar")}>Explorar destinos</button>
          <button type="button" className="secondary-button" onClick={() => navigate("/wallet")}>Ver mis ahorros</button>
        </div>
      </section>
    </div>
  );
}
